import { render, staticRenderFns } from "./dj-form-input.vue?vue&type=template&id=7428df64&scoped=true&"
import script from "./dj-form-input.vue?vue&type=script&lang=js&"
export * from "./dj-form-input.vue?vue&type=script&lang=js&"
import style0 from "./dj-form-input.vue?vue&type=style&index=0&id=7428df64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7428df64",
  null
  
)

export default component.exports